const split = window.location.hostname.split('.');
export default split.length >= 3 ? split.slice(-2).join('.') : window.location.hostname;
